
 jQuery(document).ready(function() {
// MagicLinks Set Attributes Start
   const urlParams = new URLSearchParams(window.location.search);
  const isMagiclink = urlParams.get('aca');
   // console.log("isMagiclink")
   // console.log(isMagiclink)
   // console.log("isMagiclink")
        if(isMagiclink == "64f37fab4a566da7e4c73dbc"){
                  // localStorage.setItem("MagicLinks",true);
          var formData = new FormData();
  formData.append("attributes[MagicLinks]", "true");
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => console.log(data));
        }
// MagicLinks Set Attributes End
    jQuery(".rug_review_4_rw").click(function() {
     if(window.innerWidth < 769 && $("body").hasClass("template-product-rug") == true){
     $(".mob-tab-nav button[data-tab='mob-reviews']").trigger("click");
         
       
       //  $("#REVIEWS").prop("checked", true);
     jQuery('html, body').animate({        
          scrollTop: $("#static-rev").offset().top
      }, 1000);   
     }
      else if(window.innerWidth > 768 && $("body").hasClass("template-product-rug") == true || window.innerWidth > 768 && $("body").hasClass("template-product-natural-cowhide") == true){
        jQuery('html, body').animate({        
          scrollTop: $("#static-rev").offset().top + 80
      }, 1000);   
      } 
      else{
        $(".tab-navs button[data-tab='reviews']").trigger("click");      
       //  $("#REVIEWS").prop("checked", true);
       jQuery('html, body').animate({        
          scrollTop: $(".tab-section-for-accordian").offset().top
          }, 1000);   
        }
     });
    
    setProductsData();
   removeProtection();
    if(localStorage.getItem("shopCurrency") == null || localStorage.getItem("shopCurrency") != Shopify.currency.active){
      
      setProductsData()
    localStorage.setItem('shopCurrency',Shopify.currency.active)
      
    }
    
    if(localStorage.getItem("ProtectionProductsVariant") != null && localStorage.getItem("ProtectionProductsVariant") != ''){
   removeProtection()
    }
    document.addEventListener('cart:updated', function(evt) {
    if(localStorage.getItem("ProtectionProductsVariant") != null && localStorage.getItem("ProtectionProductsVariant") != ''){
   removeProtection()
    }
  });
   });
  
  async function setProductsData(){
      var ProtectionProducts;
      const Available = await fetch(
        window.location.origin +
          "/products/shipping-protection.json",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((response) => {
        return response;
      });
      ProtectionProducts = await Available.json();
      localStorage.setItem('ProtectionProductsImage',ProtectionProducts.product.image.src)
        ProtectionProducts = ProtectionProducts.product.variants
      localStorage.setItem('ProtectionProducts',JSON.stringify(ProtectionProducts))
  }
  
   async function removeProtection(){
     jQuery.getJSON('/cart.js', function(cart) {
var protectionProduct = cart.items.find((o) => o.handle == 'shipping-protection');
  if(protectionProduct != undefined){
    var protectionId = protectionProduct.id;
    protectionId = protectionId.toString();
        fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ quantity: 0, id: protectionId})
      }).then((response) => {
          if(window.location.pathname == '/cart'){
            window.location.reload();
          }else{
         jQuery.getJSON('/cart.js', function(cart) {
          let cartData = cart.items;
          document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
          document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
               detail: cartData
          })); 
           localStorage.removeItem('IsChecked')
     localStorage.removeItem('ShippingProtectionDisplay')
           localStorage.removeItem('ProtectionProductsPercent')
         localStorage.removeItem('ProtectionProductsVariant')
         localStorage.removeItem('ProtectionProductsPrice')
     });
        }
      });
     }
      });
   }
  

  
  $(".rug_review_4_qa").click(function() {
    if(window.innerWidth < 769 && $("body").hasClass("template-product-rug") == true){
     $(".mob-tab-nav button[data-tab='mob-frequent_questions']").trigger("click");
      
   jQuery('html, body').animate({        
          scrollTop: $("#tab-section-for-accordian-mob").offset().top
      }, 1000);   
    }
    else{
     $(".tab-navs button[data-tab='frequent_questions']").trigger("click");
      
   jQuery('html, body').animate({        
          scrollTop: $(".tab-section-for-accordian").offset().top
      }, 1000);    
    }
     });
  
  
   $(".product-block .rd_mr").click(function() {
    
     $(".tab-navs button[data-tab='description']").trigger("click");
      
   jQuery('html, body').animate({        
          scrollTop: $(".tab-section-for-accordian").offset().top
      }, 1000);   
     });
  
    $(".template-product-rug .product-block .rd_mr").click(function() {
    if(window.innerWidth < 768){
     $(".template-product-rug .mob-tab-nav button[data-tab='mob-description']").trigger("click");
      
   jQuery('html, body').animate({        
          scrollTop: $("#tab-section-for-accordian-mob").offset().top
      }, 1000);   
    }
     });
  
   /* Tabs JS */
     $(".tab-navs.mob-tab-nav button").on('click', function(){
       var tab_id =  $(this).attr('data-tab');
      $(".tab-navs.mob-tab-nav button").removeClass("active");
      $(this).addClass("active");
      $(".mob-tab-item").hide();
      $('.'+ tab_id + '-tab').show();
    });
     $(".tab-navs button").on('click', function(){
       var tab_id =  $(this).attr('data-tab');
      if(window.innerWidth > 768 && tab_id == 'reviews' && $("body").hasClass("template-product-rug") == true || window.innerWidth > 768 && tab_id == 'reviews' && $("body").hasClass("template-product-natural-cowhide")){
         jQuery('html, body').animate({        
            scrollTop: $("#static-rev").offset().top + 80
        }, 1000);   
      }
       else{
        $(".tab-navs button").removeClass("active");
        $(this).addClass("active");
        $(".tab-item").hide();
        $('.'+ tab_id + '-tab').show();
       }
    });
    
  

    jQuery('.site-nav li').mouseenter(function(){
      var id = $(this).children("a").html().trim().replace(' ', '_').trim().replace(' ', '_').toLowerCase();
        id = id.replace('$','');
    
      var menu = jQuery('#'+id).html();
      $(this).append(menu);
   
    });
    jQuery('.site-nav li').mouseleave(function(){
      $('.site-nav li').find(".megamenu").remove();
      //$(".megamenu").hide();
    });
  
    $(".mobile-nav li button").on("click", function(){ 
      var id = $(this).attr("data-id"); 
      id = id.replace('$','');
      //console.log("id",id);
      $("#"+id).addClass('sub-menu--open');
      setTimeout( function() { $("#NavDrawer").css("transform", "translateX(0px)");}, 500);
    });
    $(".back-button").on("click", function(){    
      $(".menu-div").removeClass('sub-menu--open');
      $("#NavDrawer").removeAttr("style");
    });
    $("#MainContent").on("click", function(){
      $(".menu-div").removeClass('sub-menu--open');
      $("#NavDrawer").removeAttr("style");
    });
  
  /* FAQ Page */
  $(".collapse-block__title").on("click", function() {
      $(this).parent().siblings(".collapse-block").find(".collapse-block__content").slideUp( "slow" );
      $(this).parent().siblings(".collapse-block").find(".collapse-block__title").removeClass("open-faq");
      $(this).siblings().slideToggle( "slow" );
      $(this).toggleClass("open-faq");
  });
  
  
  /* Header scroll JS */
  // var didScroll;
  //   var lastScrollTop = 0;
  //   var navbarHeight = $('header').outerHeight();
  //   $(window).scroll(function (event) {
  //       didScroll = true;
      
  //         var height = $(window).scrollTop();
      
  //         if(height > lastScrollTop) {
  //           //console.log("indown");
  //             $('header').removeClass('nav-up').addClass('nav-down');
  //         }
  //         else {
  //           //console.log("inup");
  //           if (height + $(window).height() < $(document).height()) {
  //               $('header').removeClass('nav-down').addClass('nav-up');
  //           }
  //         }
  
  //         lastScrollTop = height;
  //   });

  $(window).scroll(function(){
    if($('body').hasClass("template-product") != true){
    if (window.scrollY > 250 ) {
      $(".serach_for_mob").addClass("site-header__search-popup");
    }
    else{
      $(".serach_for_mob").removeClass("site-header__search-popup");
    }
    }
    else{
      $(".serach_for_mob").addClass("site-header__search-popup");
    }
  });
  /* JS for remove error form quickview when closed */
  $(".js-modal-close").on("click", function(){ $(this).siblings(".modal__centered-content").find(".errors").remove(); });
  
  /* Video JS */
  jQuery( document ).ready(function($) {
      $('.play-ic-overlay').click(function() {
          $(this).hide();
          $(this).siblings().attr("controls","controls")
          $(this).siblings().trigger('play');
      });
  });
  
  /* Video Lazy load */
  document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();          
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });

   function lazyLoadVideo(){
      console.log('click quick')
      var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();          
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
    }
  $('.quick-product__btn').on('click',function(){
   lazyLoadVideo()
  });
  /* Search Clear Event */
   $(document).on("click", "#SearchFormClose", function(){$(".search__input").val(""); $("#predictive-search").html(" "); $("#predictive-search").hide();
                                          $("body").removeClass("predictive--open predictive-overflow-hidden");$("predictive-search").removeClass("is-active");});
  $(".js-search-header-close").on("click", function(){
    $(".search__input").val(""); $(".search__results").html(" "); $(".search__results").hide();
    $(".site-header__search-container").removeClass("is-active");$("body").removeClass("predictive--open predictive-overflow-hidden");$("predictive-search").removeClass("is-active");});
  $(".search__input").on("input", function(){
    if($(".search__input").val().length < 1){
      $("#predictive-search").hide();
      $("#predictive-search").html(" ");      
    }
  });
  
  /* Delivery Date js */
  var today = new Date();
  var month = today.getMonth()+1;
  var weekday=new Array(7);
  
  weekday[0]="Sunday";
  weekday[1]="Monday";
  weekday[2]="Tuesday";
  weekday[3]="Wednesday";
  weekday[4]="Thursday";
  weekday[5]="Friday";
  weekday[6]="Saturday";
  
  var day = weekday[today.getDay()];
  
    var nextday;
  if(day == 'Friday')
  {
   day = weekday[1];      
   nextday = today.getDate()+3;
  }
  
  else if(day == 'Saturday'){
   day = weekday[1];      
   nextday = today.getDate()+2;      
  }
  
  else
  {
  day = weekday[today.getDay()+1];
   nextday = today.getDate()+1;
  }
    day = day.toUpperCase();
  var monthNames = ["January", "February", "March", "April", "May","June","July", "August", "September", "October", "November","December"];
            
  var deliveryday = monthNames[today.getMonth()]  + " " + 
      (nextday<10 ? '0' : '') + nextday;     
    deliveryday = deliveryday.toUpperCase();
  $(".order_date_desc span").html(" " + day + " " + deliveryday);
  
              
  
/* FAQ JS for tab */
$(".faq_btn").on("click", function() {
    $(this).parent().siblings(".faq_acc").find(".faq_btn.fq_op").removeClass("fq_op");
    $(this).parent().siblings(".faq_acc").find(".faq_ans").slideUp( "slow" );
    $(this).siblings().slideToggle( "slow" );
    $(this).toggleClass("fq_op");
});



/* Product Page URL js */


/* Touch start js */
$(window).resize( function(){
  setTimeout( function(){    
    if(window.matchMedia("(pointer: coarse)").matches) {
     document.documentElement.className += ' supports-touch';
    }
    else{
      document.documentElement.classList.remove('supports-touch')
    }
  }, 3000);
});

  jQuery(document).on('click', '.banner_sec_cw.ac1', function(){   

                // Prevent the default behavior of the link (prevents scrolling to the top)
                event.preventDefault();

                // Redirect to the desired URL
                window.location.href = '/collections/cowhide-rug-clearance/';
            });


              jQuery(document).on('click', '.banner_sec_cw.ac2', function(){   

                // Prevent the default behavior of the link (prevents scrolling to the top)
                event.preventDefault();

                // Redirect to the desired URL
                window.location.href = 'https://www.cowhidesdirect.com/collections/cowhide-rug-clearance?aca=64f37fab4a566da7e4c73dbc';
            });

  // accoumt hover

 $(".account_logo").on("mouseenter",function(){
    var accmenu= $("#account-menu").html();
     $(this).append(accmenu);
})
$(".account_logo").mouseleave(function(){     
$(this).find(".account_dropdown").remove();
})